<template>
  <div id="app">
    <meny></meny>
  </div>
</template>

<script>
import Meny from './components/Meny.vue'

export default {
  name: 'app',
  components: {
    Meny
  }
}
</script>

<style lang="scss">
// https://buefy.org/documentation/customization

</style>


